import React from 'react';
import { Autocomplete as MuiAutocomplete, Checkbox, TextField } from '@mui/material';

export interface IAutocompleteOption {
  label: string;
  value: string | number;
}

interface IProps {
  onChange: (values: IAutocompleteOption[]) => void;
  options: IAutocompleteOption[];
  getOptionLabel?: (option: IAutocompleteOption) => string;
  label?: string;
  placeholder?: string;
  size?: 'small' | 'medium';
}

const Autocomplete: React.FC<IProps> = ({
  options,
  getOptionLabel = option => option.label,
  label,
  placeholder = '',
  onChange,
                                          size,
}) => {
  return (
    <div>
      <MuiAutocomplete
        multiple
        limitTags={3}
        options={options}
        disableCloseOnSelect
        size={size}
        getOptionLabel={getOptionLabel}
        renderOption={(
          props: any,
          option: IAutocompleteOption,
          { selected }: { selected: boolean },
        ) => (
          <li {...props}>
            <Checkbox style={{ marginRight: 8 }} checked={selected} />
            {option.label}
          </li>
        )}
        renderInput={(params: any) => (
          <TextField {...params} label={label} placeholder={placeholder} />
        )}
        onChange={(event, value) => {
          onChange(value);
        }}
      />
    </div>
  );
};

export default Autocomplete;
